var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfResultsGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 13H1.50003C1.30112 13 1.11035 13.079 0.969698 13.2197C0.829045 13.3603 0.750028 13.5511 0.750028 13.75C0.750028 13.9489 0.829045 14.1397 0.969698 14.2803C1.11035 14.421 1.30112 14.5 1.50003 14.5H14.5C14.6989 14.5 14.8897 14.421 15.0304 14.2803C15.171 14.1397 15.25 13.9489 15.25 13.75C15.25 13.5511 15.171 13.3603 15.0304 13.2197C14.8897 13.079 14.6989 13 14.5 13Z",
    fill: "url(#paint0_linear_0_14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.78712 1.55691C1.6961 1.51921 1.59854 1.49987 1.50003 1.5C1.35169 1.5 1.20668 1.54398 1.08334 1.62639C0.959994 1.7088 0.86386 1.82594 0.807092 1.96299C0.750324 2.10003 0.735472 2.25084 0.764413 2.39633C0.793354 2.54182 0.864789 2.67546 0.969684 2.78034L5.71968 7.53034C5.78933 7.59999 5.87201 7.65524 5.96301 7.69293C6.054 7.73063 6.15153 7.75003 6.25003 7.75003C6.34852 7.75003 6.44605 7.73063 6.53705 7.69293C6.62805 7.65524 6.71073 7.59999 6.78037 7.53034L8.50003 5.81066L12.6894 10H11C10.8011 10 10.6104 10.079 10.4697 10.2197C10.329 10.3603 10.25 10.5511 10.25 10.75C10.25 10.9489 10.329 11.1397 10.4697 11.2803C10.6104 11.421 10.8011 11.5 11 11.5H14.5C14.6989 11.5 14.8897 11.421 15.0304 11.2803C15.171 11.1397 15.25 10.9489 15.25 10.75L15.2495 7.25C15.2495 7.05109 15.1704 6.86032 15.0298 6.71967C14.8891 6.57902 14.6984 6.5 14.4995 6.5C14.3006 6.5 14.1098 6.57902 13.9691 6.71967C13.8285 6.86032 13.7495 7.05109 13.7495 7.25L13.7497 8.93903L9.03037 4.21966C8.96073 4.15001 8.87805 4.09476 8.78705 4.05707C8.69605 4.01937 8.59852 3.99997 8.50003 3.99997C8.40153 3.99997 8.304 4.01937 8.21301 4.05707C8.12201 4.09476 8.03933 4.15001 7.96968 4.21966L6.25003 5.93934L2.03037 1.71966C1.9608 1.64991 1.87813 1.59461 1.78712 1.55691Z",
    fill: "url(#paint1_linear_0_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_14",
    x1: 0.750028,
    y1: 13.75,
    x2: 12.6537,
    y2: 14.2203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_14",
    x1: 0.75,
    y1: 6.5,
    x2: 12.6718,
    y2: 6.42934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfResultsGraph);
export default __webpack_public_path__ + "static/media/cf-results-graph.6ee5f29e29ed273a9953b47f91637537.svg";
export { ForwardRef as ReactComponent };